import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ReportingReportableAssetFolderId = Brand<number, 'ReportingReportableAssetFolderId'>;
export const ReportingReportableAssetFolderId = createBranded<ReportingReportableAssetFolderId>();
